module.exports = __webpack_public_path__ + "files/8a50ed1854b409cb1ff1f6f59904808f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Exo-2-regular.svg
 ** module id = 852
 ** module chunks = 0
 **/